/**
 * Close 关闭状态
 */
const Close = () => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="7.55" cy="20.392" r="1.55" fill="black" />
      <circle cx="17.55" cy="20.392" r="1.55" fill="black" />
      <path
        d="M1.5 3.05273H4.10677L5.0095 3.88978L5.32899 6.22614M5.32899 6.22614L6.33293 16.7369H18.9347L20.8211 14.9757L21.5 6.22614H5.32899Z"
        stroke="black"
        strokeWidth="2"
      />
    </svg>
  )
}

export default Close
